import { wsStatsApiDefaults } from './defaults';
import GumboModel from '../models/GumboModel';

export default {
    ...wsStatsApiDefaults,
    pathTemplate: 'api/v1.1/game/{gamePk}/feed/live{differ}?language={language}{timecode}{pushUpdate}',
    expires: 9,
    model: GumboModel
};
